import axios from '../../services/axios'

import * as actionTypes from './actionTypes';
import { setEducationForms } from '../../services/generalService';

import { setMessage } from './message';

export const loadFaculties = () => {
    return {
        type: actionTypes.LOAD_FACULTIES
    }
}

export const setFaculties = (faculties) => {
    return {
        type: actionTypes.SET_FACULTIES,
        faculties: faculties
    }
}

export const getFaculties = () => {
    return (dispatch) => {
        dispatch(loadFaculties())
        axios.get( `/api/v1/list-disciplines/faculty` )
            .then( response => {
                dispatch( setFaculties(response.data))
            } )
            .catch( error => {
                dispatch( setFaculties([]))
                dispatch( setMessage({type: 'warning', text: "Не удалось подключиться к серверу."}))
            } );
    }
}

export const loadSpecialitiesByFaculty = () => {
    return {
        type: actionTypes.LOAD_SPECIALITIES_BY_FACULTY
    }
}

export const setSpecialitiesByFaculty = (specialities) => {
    return {
        type: actionTypes.SET_SPECIALITIES_BY_FACULTY,
        specialitiesByFaculty: specialities,
        educationForms: setEducationForms(specialities)
    }
}

export const getSpecialitiesByFaculty = (facultyId) => {
    return (dispatch) => {
        dispatch(loadSpecialitiesByFaculty())
        axios.get( `/api/v1/rating/specialities?facultyId=${facultyId}` )
            .then( response => {
                dispatch( setSpecialitiesByFaculty(response.data))
            } )
            .catch( _error => {
                dispatch( setSpecialitiesByFaculty([]))
                dispatch( setMessage({type: 'warning', text: "Не удалось подключиться к серверу."}))
            } );
    }
}

export const loadCoursesByFacultyAndSpeciality = () => {
    return {
        type: actionTypes.LOAD_COURSES_BY_FACULTY_AND_SPECIALITY
    }
}

export const setCoursesByFacultyAndSpeciality = (courses) => {
    return {
        type: actionTypes.SET_COURSES_BY_FACULTY_AND_SPECIALITY,
        coursesByFacultyAndSpeciality: courses,
    }
}

export const getCoursesByFacultyAndSpeciality = (facultyId, specialityId) => {
    return (dispatch) => {
        dispatch(loadCoursesByFacultyAndSpeciality())
        axios.get( `/api/v1/rating/courses?facultyId=${facultyId}&specialityId=${specialityId}` )
            .then( response => {
                dispatch( setCoursesByFacultyAndSpeciality(response.data))
            } )
            .catch( _error => {
                dispatch( setCoursesByFacultyAndSpeciality([]))
                dispatch( setMessage({type: 'warning', text: "Не удалось подключиться к серверу."}))
            } );
    }
}

export const loadDisciplines = () => {
    return {
        type: actionTypes.LOAD_DISCIPLINES
    }
}

export const setDisciplines = (disciplines) => {
    return {
        type: actionTypes.SET_DISCIPLINES,
        disciplines: disciplines,
    }
}

export const getDisciplines = (specialityId, course, term, isForeign = false) => {
    return (dispatch) => {
        dispatch(loadDisciplines())
        const params = {
            id: specialityId,
            course: course,
            isForeign: isForeign,
            term: term
        };
        axios.get(`/api/v1/list-disciplines`, { params })
            .then( response => {
                response.data = response.data.map((el, index) => {return {index: index,...el}})
                dispatch(setDisciplines(response.data))
            } )
            .catch( error => {
                dispatch(setDisciplines([]))
                dispatch(setMessage({type: 'warning', text: "Не удалось подключиться к серверу."}))
            } );
    }
}

export const loadRating = () => {
    return {
        type: actionTypes.LOAD_RATING
    }
}

export const setRating = (rating) => {
    return {
        type: actionTypes.SET_RATING,
        rating: rating,
    }
}

export const getRating = (specialityId, course) => {
    return (dispatch) => {
        dispatch(loadRating())
        axios.get( `/api/v1/rating?sdef=${specialityId}&course=${course}` )
            .then( response => {
                response.data.sort((a, b) => b.average - a.average)
                dispatch( setRating(response.data))
            } )
            .catch( error => {
                dispatch( setRating([]))
                dispatch( setMessage({type: 'warning', text: "Не удалось подключиться к серверу."}))
            } );
    }
}

export const loadRatingDetails = () => {
    return {
        type: actionTypes.LOAD_RATING_DETAILS
    }
}

export const setRatingDetails = (ratingDetails) => {
    return {
        type: actionTypes.SET_RATING_DETAILS,
        ratingDetails: ratingDetails,
    }
}

export const getRatingDetails = (studentCardNumber) => {
    return (dispatch) => {
        dispatch(loadRatingDetails())
        axios.get( `/api/v1/rating/studentRating?studentCardNumber=${studentCardNumber}` )
            .then( response => {
                dispatch( setRatingDetails(response.data))
            } )
            .catch( error => {
                dispatch( setMessage({type: 'warning', text: "Не удалось подключиться к серверу."}))
            } );
    }
}
